export type SplitCols = 'splits.prev_split_diff' | 'splits.result_diff';

export const splitFields = {
  'splits.prev_split_diff': 'splits.prev_split_diff',
  'splits.result_diff': 'splits.result_diff',
};
